import { instance } from './ApiRequest';
import {
    GET_CANDIDATE_DETAILS, UPDATE_CANDIDATE_TRANSACTION_DATA
} from 'constants/constants';

let _BankAdminServices = {
    async GetCandidateData(applicationID) {
        return await instance.get(GET_CANDIDATE_DETAILS+"?applicationId="+applicationID);
    },    

    async updateCandidateTransactionID(data) {
        return await instance.post(UPDATE_CANDIDATE_TRANSACTION_DATA, data);
    }, 
}

export default _BankAdminServices;